import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import equal from "fast-deep-equal";

import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as globalReducer from "containers/App/reducer";
import * as marketReducer from "containers/Market/MarketReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Hexagon from "components/Next/Hexagon";

import { HEXAGON_NODES } from "containers/Next/NextReducer";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class HexagonContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      chartLabelKey,
      selectedHex,
      hex,
      hexSize,
      opacity,
      selectionDirection,
      isSelectedActionHex,
      isHighlight,
      isFaded,
      isPinned,
      isDragHex,
      hexOrder,
      isInHexMap,
      isInReport,
      node,
      isExploreReady,
      isAnimateReturn,
      viewIndex,
      hasActions,
      hasActionsAlt,
      isMini
    } = this.props;

    if (hasActionsAlt !== nextProps?.hasActionsAlt && isMini !== true) {
      return true;
    }

    if (hasActions !== nextProps?.hasActions && isMini !== true) {
      return true;
    }

    if (viewIndex !== nextProps?.viewIndex && node?.isDirection) {
      return true;
    }

    if (
      viewIndex !== nextProps?.viewIndex &&
      node?.chart?.metadata?.type === "Difference" &&
      selectedHex?.chart?.narrative?.title === node?.chart?.narrative?.title
    ) {
      return true;
    }

    if (node?.x !== nextProps?.node?.x || node?.y !== nextProps?.node?.y) {
      return true;
    }

    if (isHighlight !== nextProps.isHighlight && isMini !== true) {
      return true;
    }

    if (isInReport !== nextProps?.isInReport) {
      return true;
    }

    if (isInHexMap !== nextProps?.isInHexMap) {
      return true;
    }

    if (hexOrder !== nextProps?.hexOrder) {
      return true;
    }

    if (isDragHex || nextProps?.isDragHex === true) {
      return true;
    }

    if (node?.color !== nextProps?.node?.color) {
      return true;
    }

    if (isExploreReady !== nextProps?.isExploreReady) {
      return true;
    }

    const cTitle = node?.chart?.title || node?.chart?.narrative?.title;
    const nTitle = nextProps?.node?.chart?.title || nextProps?.node?.chart?.narrative?.title;

    if (cTitle !== nTitle) {
      return true;
    }

    const isSelectChange =
      selectedHex &&
      nextProps.selectedHex &&
      (selectedHex.x !== nextProps.selectedHex.x || selectedHex.y !== nextProps.selectedHex.y);

    const isSelectRelevant =
      selectedHex &&
      nextProps.selectedHex &&
      (selectedHex.x === hex.x ||
        selectedHex.y === hex.y ||
        nextProps.selectedHex.x === hex.x ||
        nextProps.selectedHex.y === hex.y);

    if (
      (selectionDirection === undefined && nextProps.selectionDirection !== undefined) ||
      (nextProps.selectionDirection === undefined && selectionDirection !== undefined)
    ) {
      return true;
    }

    if (selectionDirection && nextProps.selectionDirection && selectionDirection !== nextProps.selectionDirection) {
      if (
        (nextProps.node && nextProps.node.type === selectionDirection.type) ||
        (nextProps.node && nextProps.node.type === nextProps.selectionDirection.type)
      ) {
        return true;
      }
    }

    if (isSelectedActionHex !== nextProps.isSelectedActionHex) {
      return true;
    }

    if (isFaded !== nextProps.isFaded) {
      return true;
    }

    if (isPinned !== nextProps.isPinned) {
      return true;
    }

    if (node?.chart?.narrative?.title === nextProps?.node?.chart?.narrative?.title) {
      return false;
    }

    if (
      hexSize !== nextProps.hexSize ||
      (isSelectChange && isSelectRelevant) ||
      (node && nextProps.node && node.type !== nextProps.node.type) ||
      (node && nextProps.node && node.direction !== nextProps.node.direction)
    ) {
      return true;
    } else {
      return false;
    }

    return false;
  }

  render() {
    const { hex, selectedHex, isMini } = this.props;

    //console.log("hexagon rerender isMini", isMini);

    const isMounted = hex;

    return isMounted ? <Hexagon {...this.props} /> : <div />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    moveHex: (fHex, tHex, node) => {
      dispatch(nextReducer.moveHex(id, fHex, tHex, node));
    },
    addPinned: () => dispatch(nextReducer.addPinned(id)),
    resetActions: () => dispatch(nextReducer.resetActions(id, true)),
    updateSelectedHex: (hex, node) => dispatch(nextReducer.updateSelectedHex(id, hex, node)),
    updatePinnedHex: (hex, node) => dispatch(nextReducer.updatePinnedHex(id, hex, node)),
    addToPinnedHexList: (node) => dispatch(nextReducer.addToPinnedHexList(id, node)),
    updateHexOrder: (hex, isRight) => dispatch(nextReducer.updateHexOrder(id, hex, isRight)),
    updateSelectionDirection: (direction) => dispatch(nextReducer.updateSelectionDirection(id, direction)),
    updateSelectedChart: (hex, node) => dispatch(nextReducer.updateSelectedChart(id, hex, node)),
    updateSearchChart: (hex, node) => dispatch(nextReducer.updateSearchChart(id, hex, node)),
    updateHexMap: (hexMap) => dispatch(nextReducer.updateHexMap(id, hexMap)),
    centerHex: (hex, isSmooth) => dispatch(nextReducer.centerHex(hex, isSmooth)),
    updateHover: (node) => dispatch(nextReducer.updateHover(id, node)),
    updateDragHex: (hex) => dispatch(nextReducer.updateDragHex(id, hex)),
    showMore: () => dispatch(nextReducer.showMore(id)),
    showLess: () => dispatch(nextReducer.showLess(id)),
    addToDo: (node) => dispatch(nextReducer.addToDo(id, node)),

    removeNode: (hex, node) => dispatch(nextReducer.removeNode(id, hex, node)),
    removeAllNodes: (node) => dispatch(nextReducer.removeAllNodes(id, node)),

    scrollReportByTitle: (val) => dispatch(nextReducer.scrollReportByTitle(id, val)),

    replayActions: (stopNode) => dispatch(nextReducer.replayActions(id, stopNode)),

    viewConsultants: () => dispatch(marketReducer.viewConsultants()),
    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  const nodes = ownProps?.nodes
    ? ownProps?.nodes
    : ownProps.node
      ? [ownProps.node]
      : nextReducer.getHexNodes(state, id, ownProps.hex);

  const sNode = nextReducer.getHexNode(state, id, ownProps.hex);

  const node = ownProps.node ? ownProps.node : nodes && nodes.length > 0 ? nodes[nodes.length - 1] : sNode;

  const hexSize = ownProps.hexSize ? ownProps.hexSize : nextReducer.getHexSize(state, id);

  if (ownProps?.isMini) {
    return { id: id, node: node, nodes: nodes };
  }

  const comparisonOptions = nextReducer.getComparisonOptions(state, id);

  return {
    id: id,

    isExploreReady: homeReducer.getIsExploreReady(state, nextReducer.getDatasetId(state, id)),

    node: node,
    nodes: nodes,

    isAnimateReturn: node?.isFromActionMap === true && nextReducer.getIsAnimateReturn(state, id),

    hasViewed: nextReducer.getHasViewed(state, id, node),

    selectionDirection: nextReducer.getSelectionDirection(state, id),

    isInPath: nextReducer.getIsInPath(state, id, ownProps.hex),

    //chartLabelKey: nextReducer.getChartLabelKey(state, id, ownProps.hex),

    isDistribution: nextReducer.getIsDistribution(state, id),

    hexSize: hexSize,
    innerHexSize: nextReducer.calcInnerHexSize(hexSize),
    hexagonRadius: nextReducer.getHexagonRadius(state, id),

    selectedHex: nextReducer.getSelectedHex(state, id),
    selectedChart: nextReducer.getSelectedChart(state, id),

    isHighlight: nextReducer.getIsHighlight(state, id, ownProps.hex, node),

    isFaded: nextReducer.getIsFaded(state, id, ownProps.hex, ownProps.mType),
    isPinned: nextReducer.getIsPinned(state, id, ownProps.hex, node),
    isInReport: ownProps?.node?.isFromActionMap !== true ? true : nextReducer.getIsInReport(state, id, node),
    hasPins: nextReducer.getHasPins(state, id),
    hasActions:
      (!comparisonOptions || ownProps?.node?.type !== HEXAGON_NODES.SECOND_ORDER_CHART) &&
      (ownProps.mType === "EXPLORE" || ownProps.mType === undefined) &&
      (ownProps?.node?.isFromActionMap !== true ? false : nextReducer.getHasActions(state, id)),

    hasActionsAlt: nextReducer.getHasActions(state, id),

    isSelectedActionHex: nextReducer.getIsSelectedActionHex(state, id, ownProps.hex, node),
    isInHexMap: nextReducer.getIsInHexMap(state, id, node),

    stopAnimation: nextReducer.getStopAnimation(state, id),

    totalChartCount: nextReducer.getTotalChartCount(state, id),

    viewIndex: nextReducer.getViewIndex(state, id),

    hexOrder: nextReducer.getHexOrderHex(state, id, ownProps.hex),

    isLastMoveChart: nextReducer.getIsLastMoveChart(state, id, node),

    comparisonOptions: comparisonOptions
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(HexagonContainer);
